<template>
    <div>alert{{msg}}</div>
</template>

<script>
    export default {
        ame: 'Alert',
        props: {
            msg: String
        }
    }
</script>


// WEBPACK FOOTER //
// alert.vue?75827690